// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__eGElJ","lastLink":"HeadPage_lastLink__aXSbZ"};